<template>
  <div class="f-form__pair f-form__pair--3-1">
    <f-text
      :id="`event_name_${index}`"
      label="Event Name"
      :value="value.name"
      required
      :error="e('name')"
      @input="update('name', $event)"
    />
    <f-text
      :id="`event_cost_${index}`"
      label="Cost"
      type="number"
      min="0"
      :value="value.cost"
      required
      :error="e('cost')"
      @input="update('cost', $event)"
    />
  </div>
</template>

<script>
import FText from '@/components/FormFields/FText'
import FTextarea from '@/components/FormFields/FTextarea'
import FCheckbox from '@/components/FormFields/FCheckbox'
import FSearchSelect from '@/components/FormFields/FSearchSelect'

export default {
  name: 'EventFieldsSection',
  components: { FText, FTextarea, FCheckbox, FSearchSelect },
  props: {
    value: { type: Object, required: true },
    eventTypes: { type: Array, default: () => [] },
    loadingTypes: { type: Boolean, default: false },
    errors: { type: Object, default: () => ({}) },
    index: { type: Number, default: 0 }
  },
  methods: {
    e(field) {
      const key = `events.${this.index}.${field}`
      return this.errors[key] ? this.errors[key][0] : null
    },
    update(field, val) {
      this.$emit('input', { ...this.value, [field]: val })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Events/EventFieldsNameSection.vue